const messages = {
    root: {
        menuTitle: 'Zamawianie dokumentu',
        pageTitle: 'Zamawianie dokumentu'
    },
    list: {
        menuTitle: 'Lista dokumentów',
        pageTitle: 'Zamawianie dokumentu / Lista dokumentów',
        title: 'Zamawianie dokumentów',
        actions: {
            create: 'Zamów dokument',
            open: 'Otwórz',
            applyFilters: 'Zastosuj filtry',
            clearFilters: 'Wyczyść',
            openFilters: 'Filtry',
            closeFilters: 'Zamknij filtry'
        },
        filters: {
            type: 'Rodzaj dokumentu',
            typePlaceholder: 'Wybierz rodzaj',
            status: 'Status',
            statusPlaceholder: 'Wybierz status',
            productionDepartment: 'Dział produkcji',
            productionDepartmentPlaceholder: 'Wybierz dział',
            authors: 'Autorzy',
            authorsPlaceholder: 'Wyszukaj autora',
            createdAtFrom: 'Data utworzenia od',
            createdAtTo: 'Data utworzenia do',
            noData: 'Brak danych',
            noResults: 'Brak wynikow'
        },
        table: {
            headers: {
                number: 'Numer zgłoszenia',
                type: 'Rodzaj dokumentu',
                productionDepartment: 'Dział',
                status: 'Status',
                proposedDate: 'Proponowany termin',
                createdAt: 'Data utworzenia',
                createdBy: 'Zgłaszający',
                actions: 'Akcje'
            }
        }
    },
    document: {
        create: {
            pageTitle: 'Zamawianie nowego dokumentu'
        },
        edit: {
            pageTitle: 'Zamawianie dokumentu / Edycja zamówienia'
        },
        title: {
            create: 'Zamawianie nowego dokumentu',
            edit: 'Edycja zamówienia dokumentu'
        },
        actions: {
            backToList: 'Powrót do listy',
            save: 'Zapisz',
            share: 'Udostępnij',
            sendComment: 'Wyślij'
        },
        tabs: {
            details: 'Szczegóły',
            attachments: 'Załączniki',
            comments: 'Komentarze'
        },
        details: {
            fields: {
                type: 'Rodzaj dokumentu',
                productionDepartment: 'Dział',
                proposedDate: 'Proponowany termin',
                status: 'Status'
            },
            noTypes: 'Nie znaleziono rodzajów',
            noDepartments: 'Nie znaleziono działu',
            noStatuses: 'Brak statusów do zmiany.',
            validation: {
                productionDepartmentRequired: 'Dział jest wymagany',
                typeRequired: 'Rodzaj dokumentu jest wymagany',
                proposedDateRequired: 'Data jest wymagana'
            }
        },
        attachments: {
            fileLabel: 'Pliki',
            filePlaceholder: 'Wybierz pliki',
            add: 'Dodaj',
            deleteTitle: 'Usuwanie załącznika',
            deleteContent: 'Czy na pewno chcesz usunąć załącznik: {fileName}?',
            deleteConfirm: 'Usuń',
            deleteTooltip: 'Usuń',
            downloadTooltip: 'Kliknij żeby pobrać',
            cancelUpload: 'Anuluj',
            noAttachments: 'Nie dodano załączników.',
            maxSizeInfo: 'Dopuszczalny rozmiar pojedynczego pliku: {size} MB',
            maxSizeError: 'Przekroczono dopuszczalny rozmiar pliku: {size} MB.',
            table: {
                fileName: 'Nazwa pliku',
                actions: 'Akcje'
            }
        },
        comments: {
            empty: 'Brak komentarzy do zamówienia.',
            pendingInfo: 'Komentarze zostaną zapisane po utworzeniu dokumentu.',
            addLabel: 'Dodaj komentarz',
            table: {
                content: 'Treść',
                author: 'Autor',
                createdAt: 'Data i godzina utworzenia'
            }
        },
        share: {
            title: 'Udostępnij dokument',
            usersWithAccess: 'Użytkownicy z dostępem:',
            authorLabel: 'Autor zgłoszenia',
            addUsers: 'Dodaj użytkowników:',
            searchUsers: 'Wyszukaj użytkowników',
            noUsers: 'Nie znaleziono użytkowników',
            cancel: 'Anuluj',
            save: 'Zapisz',
            noData: 'Brak danych'
        },
        notifications: {
            invalidForm: 'Formularz zawiera błędy.'
        }
    },
    notifications: {
        documentCreated: 'Zamówienie dokumentu zostało dodane.',
        documentUpdated: 'Zamówienie dokumentu zostało zaktualizowane.'
    },
    errors: {
        fetchDocuments: 'Pobranie listy zamówień dokumentów nie powiodło się.',
        fetchProductionDepartments: 'Pobranie działów nie powiodło się.',
        fetchTypes: 'Pobranie rodzajów dokumentów nie powiodło się.',
        fetchStatuses: 'Pobranie statusów zamówień dokumentów nie powiodło się.',
        createDocument: 'Zgłoszenie zamówienia dokumentu nie powiodło się.',
        fetchDocument: 'Pobranie zamówienia dokumentu nie powiodło się.',
        updateDocument: 'Aktualizacja zamówienia dokumentu nie powiodła się.',
        fetchComments: 'Pobranie komentarzy do zamówienia dokumentu nie powiodło się.',
        createComment: 'Dodanie komentarza do zamówienia dokumentu nie powiodło się.',
        createAttachment: 'Dodanie załącznika nie powiodło się.',
        fetchEligibleUsers: 'Pobranie listy użytkowników nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
